const headerSl = {
	brand: 'ග්‍රාමීන් බසාර්',
	top: {
		bazarList: 'බසාර්',
		help: 'උදව්',
		contact: 'සම්බන්ධ වන්න',
	},
	nav: {
		dailyBazar: 'දෛනික බසාර්',
		medicineBazar: 'ඖෂධ',
		foodBazar: 'තাজා ආහාර',
		grains: 'ධාන්ය',
		nationalBazar: 'ජාතික',
		garmentsBazar: 'ඇඳුම්',
		cosmeticsBazar: 'ඇලංකාර',
		bookBazar: 'පොත්',
		nurseryBazar: 'නර්සරී',
		electronicsBazar: 'ඉලෙක්ට්‍රොනික',
		chemicalBazar: 'රසායන',
		hardwareBazar: 'හාර්ඩ්වෙයාර්',
		serviceBazar: 'සේවා',
		feedBazar: 'සත්ව ආහාර',
	},
	search: {
		placeholder: 'ඔබට අවශ්‍ය දේ සෙවෙන්න?'
	},
	drawer: {
		home: 'මුලපිට',
		dailyBazar: 'දෛනික බසාර්',
		medicineBazar: 'ඖෂධ බසාර්',
		grains: 'ධාන්ය බසාර්',
		nationalBazar: 'ජාතික බසාර්',
		foodBazar: 'තాజා ආහාර',
		bookBazar: 'පොත් බසාර්',
		nurseryBazar: 'නර්සරී බසාර්',
		garmentsBazar: 'ඇඳුම් බසාර්',
		electronicsBazar: 'ඉලෙක්ට්‍රොනික බසාර්',
		chemicalBazar: 'රසායන බසාර්',
		hardwareBazar: 'හාර්ඩ්වෙයාර් බසාර්',
		cosmeticsBazar: 'ඇලංකාර බසාර්',
		serviceBazar: 'සේවා බසාර්',
		feedBazar: 'සත්ව ආහාර බසාර්',
	},
	profileMenu: {
		login: 'ලොගින් වන්න',
		register: 'ලියාපදිංචි වන්න',
		myAccount: 'මගේ ගිණුම',
		storeDashboard: 'ස්ටෝර් ඩෑෂ්බෝඩ්',
		adminDashboard: 'පරිපාලක ඩෑෂ්බෝඩ්',
	},
};

export default headerSl;


